export const initialValues = {
    rut: "",
    numeroSolicitud: ""
};